<template>


<center  style="padding-top: 225px;" v-bind="bind_search_center">
  <v-img :src="logoTrSearchEngine" height="92px" contain
    v-bind="bind_logo" />
  <br />
  <v-text-field
    autofocus
    @keyup.enter="search()"
    name="search"
    solo
    label="Search"
    id="searchInput"
    v-model="searchInput"
    position="center center"
    style="width: 425px;"
    autocomplete="off"
    v-bind="bind_search_input" />

  <v-btn type="submit" small  @click.prevent="search()" style="background-color: #f6a200;" class="white--text"
    position="center center" >Search</v-btn>


  <v-img v-bind="bind_arrow" :src="arrow" contain width="80px" style="left:-280px; " />
  <div v-bind="bind_arrow_text" style="font-size: 25px; bottom:35px;position:relative;" >
    <strong>Don't be shy, try it right now, it is free!</strong></div>
</center>


</template>
<script>
import { mapState, mapMutations } from 'vuex'
export default {
  name: 'home',
  data () {
    return {
      logoTrSearchEngine: require('../assets/Logo TR Search Engine.png'), // eslint-disable-line no-undef
      tileBackground: require('../assets/AdobeStock_172421142_Preview-4k.jpg'), // eslint-disable-line no-undef
      logoTrSeWiki: require('../assets/Logo TR Search Engine & Wiki.png'), // eslint-disable-line no-undef
      logoContineo: require('../assets/Logo Contineo.png'), // eslint-disable-line no-undef
      logoTrToolbox: require('../assets/Logo TR Toolbox.png'), // eslint-disable-line no-undef
      tfwaDfwc: require('../assets/TFWA-DFWC.png'), // eslint-disable-line no-undef
      logoTfwa: require('../assets/TFWA.png'), // eslint-disable-line no-undef
      arrow: require('../assets/arrow.png'), // eslint-disable-line no-undef
      searchInput: ''
    }
  },
  computed: {
    ...mapState([
      'authenticated',
      'user'
    ]),
    bind_search_center () {
      const binding = {}
      if (this.$vuetify.breakpoint.smAndDown) binding.style = 'padding-top: 150px!important;'
      return binding
    },
    bind_logo () {
      const binding = {}
      if (this.$vuetify.breakpoint.smAndDown) binding.style = 'height:50px'
      return binding
    },
    bind_search_input () {
      const binding = {}
      if (this.$vuetify.breakpoint.smAndDown) binding.style = 'width: 92%;'
      return binding
    },
    bind_arrow () {
      const binding = {}
      if (this.$vuetify.breakpoint.smAndDown) binding.style = 'left: -140px;'
      return binding
    },
    bind_arrow_text () {
      const binding = {}
      if (this.$vuetify.breakpoint.smAndDown) binding.style = 'width: 280px; left: 32px;'
      return binding
    }
  },
  methods: {
    ...mapMutations(['setGlobalSearch']),
    search () {
      this.setGlobalSearch(this.searchInput)
      this.$router.push({ path: 'press' })
    }
  }
}
</script>
<style>
</style>
